let keyTaskTable = [
  {
    label: "序号",
    prop: "taskId",
  },
  {
    label: "任务分类",
    prop: "taskCategory",
  },
  {
    label: "工作内容",
    prop: "taskDetail",
  },
  {
    label: "评价标准",
    prop: "evaCriterion",
  },
  {
    label: "分值",
    prop: "totalScore",
  },
  {
    label: "牵头科室",
    prop: "leaderDept",
  },
  {
    label: "责任人",
    prop: "respPerson",
  },
  {
    label: "配合科室",
    prop: "coDept",
  },
  {
    label: "具体工作人员",
    prop: "specificPerson",
  },
  {
    label: "开始时间",
    prop: "beginDate",
  },
  {
    label: "截止时间",
    prop: "endDate",
  },
  {
    label: "完成情况",
    prop: "accomplishDetail",
  },
  {
    label: "备注",
    prop: "remarks",
  },
  {
    label: "是否派发",
    prop: "distribute",
  },
];

let keyTaskList = [
  {
    taskId: 100,
    taskCategory: "测试类型",
    taskDetail: "asdas",
    evaCriterion: "dasdas",
    score: "12",
    leaderDept: "",
    respPerson: "",
    coDept: "",
    specificPerson: "",
    beginDate: "",
    endDate: "",
    accomplishDetail: "",
    remarks: "备注",
    distribute: "是",
  },
  {
    taskId: 101,
    taskCategory: "测试类型",
    taskDetail: "asdas",
    evaCriterion: "dasdas",
    score: "12",
    leaderDept: "",
    respPerson: "",
    coDept: "",
    specificPerson: "",
    beginDate: "",
    endDate: "",
    accomplishDetail: "",
    remarks: "备注",
    distribute: "是",
  }
]
export {
  keyTaskTable,
  keyTaskList
}